import React, { useContext } from "react";
import { useSelector } from "react-redux";
import DomainContext from "Context/DomainContext";
import CartItems from "../CartItems";
import ApplyCouponSection from "../Coupon";
import PriceDetailSection from "../PriceDetails";
import UpsContent from "../UpsContent";
import QuoteForm from "../QuoteForm";
import ProductSlider from "Components/ProductSlider";
import Seo from "Components/Seo/Seo";
import useScrollToTop from "Components/Hooks/useScrollToTop";
import "./styles.scss";
import { useTranslation } from 'react-i18next';

function Quote() {
  useScrollToTop();

  const { storeId } = useContext(DomainContext);
  const recentProducts = useSelector((state) => state?.recentProducts);
  const cartDetails = useSelector((state) => state?.cartItems?.[0]);

  const hasItems = cartDetails?.totals_detail?.items?.length > 0;
  const isSample = cartDetails?.totals_detail?.isSample === 1;
  const hasMessage = !!cartDetails?.totals_detail?.message;
 const { t } = useTranslation();
  return (
    <>
      <Seo
        metaTitle={
          storeId === 1
            ? "Vrijblijvende offerte aanvraag | Promofit.nl"
            : "Vrijblijvende offerte aanvraag | Expofit.nl"
        }
        metaDescription="Citaat"
        metaKeywords="Citaat"
      />

      <div className="cartpage">
        <div className="container px-4 py-8 xl-py-14">
          <div className="cartpage__container responsive-cart xl-flex xl-gap-x-17">
            <div className="cart__details xl-flex-1">
              <h1 className="fw-700 fs-32">{t("Vrijblijvende_offerte_aanvraag")}</h1>
              <CartItems />
              {hasItems && (
                <div className="flex right coupon__quotepage pt-4">
                  <div className="coupon__section__parent">
                    {!isSample && <ApplyCouponSection />}
                    <PriceDetailSection />
                  </div>
                </div>
              )}
            </div>

            <div className="sidebar__cartpage xl-flex-0 sidebar__quotepage">
              <div className="sticky-kort">
                {!hasMessage && <QuoteForm />}
                <UpsContent />
              </div>
            </div>
          </div>
        </div>

        {hasMessage && recentProducts?.length > 0 && (
          <div className="cart__product__slider">
            <ProductSlider
              title="Recent bekeken"
              data={recentProducts}
              pageName="quote"
            />
          </div>
        )}
      </div>
    </>
  );
}

export default Quote;
